import './Footer.css';
import logo from '../../logo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { useTranslation } from 'react-i18next';

function Footer() {
  const { t } = useTranslation();
  
  // Function për smooth scrolling
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer-pro" id="contact">
      <div className="footer-columns">
        <div className="footer-col">
            <img src={logo} alt="ShalaAccounting Logo" width={50} />
          <p className="footer-desc">{t('about.desc')}</p>
        </div>
        <div className="footer-col">
          <h4>{t('header.services')}</h4>
          <a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection('services'); }}>
            {t('services.service1.title')}
          </a>
          <a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection('services'); }}>
            {t('services.service2.title')}
          </a>
          <a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection('services'); }}>
            {t('services.service3.title')}
          </a>
          <a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection('services'); }}>
            {t('services.service4.title')}
          </a>
          <a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection('services'); }}>
            {t('services.service5.title')}
          </a>
          <a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection('services'); }}>
            {t('services.service6.title')}
          </a>
          <a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection('services'); }}>
            {t('services.service7.title')}
          </a>
          <a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection('services'); }}>
            {t('services.service8.title')}
          </a>
          <a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection('services'); }}>
            {t('services.service9.title')}
          </a>
          <a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection('services'); }}>
            {t('services.service10.title')}
          </a>
        </div>
        <div className="footer-col">
          <h4>{t('header.about')}</h4>
          <a href="#about" onClick={(e) => { e.preventDefault(); scrollToSection('about'); }}>
            {t('about.title')}
          </a>
          <a href="#whyus" onClick={(e) => { e.preventDefault(); scrollToSection('whyus'); }}>
            {t('header.whyus')}
          </a>
          <a href="#collaboration" onClick={(e) => { e.preventDefault(); scrollToSection('collaboration'); }}>
            {t('footer.collaboration')}
          </a>
          <a href="#contact" onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }}>
            {t('header.contact')}
          </a>
        </div>
        <div className="footer-col">
          <h4>{t('header.contact')}</h4>
          <div className="footer-contact">+383 44 220 640</div>
          <div className="footer-contact">info@shalaaccounting.com</div>
          <div className="footer-contact">www.shalaaccounting.com</div>
          <div className="footer-social">
            <a href="https://www.facebook.com/profile.php?id=61577223991221" aria-label="Facebook" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faFacebook} />
            </a>
            <a href="https://www.instagram.com/shalaaccounting/" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faInstagram} />
            </a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} ShalaAccounting. {t('footer.rights')}</span>
        <span className="footer-links">
          <a href="/resources/terms-of-service">
            {t('footer.terms')}
          </a>
        </span>
      </div>
    </footer>
  );
}

export default Footer; 